import type { Locale } from "@/lib/i18n";

export type ShellStrings = {
  nav: {
    about: string;
    projects: string;
    publications: string;
    news: string;
    gallery: string;
    partners: string;
    documents: string;
    contacts: string;
  };
  headerCta: string;
  brandTagline: string;
  ariaOpenMenu: string;
  ariaCloseMenu: string;
  footer: {
    aboutTitle: string;
    aboutBlurb: string;
    resourcesTitle: string;
    contactsTitle: string;
    socialTitle: string;
    bottomTagline: string;
  };
};

const byLocale: Record<Locale, ShellStrings> = {
  en: {
    nav: {
      about: "About",
      projects: "Projects",
      publications: "Publications",
      news: "News",
      gallery: "Gallery",
      partners: "Partners",
      documents: "Documents",
      contacts: "Contacts",
    },
    headerCta: "Publications",
    brandTagline: "environment · sustainable development · public participation",
    ariaOpenMenu: "Open menu",
    ariaCloseMenu: "Close menu",
    footer: {
      aboutTitle: "About",
      aboutBlurb:
        "Independent non-profit expert and analytical organization established in 2009 in Bishkek, Kyrgyz Republic.",
      resourcesTitle: "Resources",
      contactsTitle: "Contacts",
      socialTitle: "Social",
      bottomTagline: "Evidence-based public policy and dialogue",
    },
  },
  ru: {
    nav: {
      about: "О нас",
      projects: "Проекты",
      publications: "Публикации",
      news: "Новости",
      gallery: "Галерея",
      partners: "Партнёры",
      documents: "Документы",
      contacts: "Контакты",
    },
    headerCta: "Публикации",
    brandTagline: "экология · устойчивое развитие · общественное участие",
    ariaOpenMenu: "Открыть меню",
    ariaCloseMenu: "Закрыть меню",
    footer: {
      aboutTitle: "О фонде",
      aboutBlurb:
        "Независимая некоммерческая экспертно-аналитическая организация, основанная в 2009 году в Бишкеке, Кыргызская Республика.",
      resourcesTitle: "Материалы",
      contactsTitle: "Контакты",
      socialTitle: "Соцсети",
      bottomTagline: "Доказательная политика и диалог",
    },
  },
  ky: {
    nav: {
      about: "Биз жөнүндө",
      projects: "Долбоорлор",
      publications: "Басылмалар",
      news: "Жаңылыктар",
      gallery: "Галерея",
      partners: "Өнөктөштөр",
      documents: "Документтер",
      contacts: "Байланыш",
    },
    headerCta: "Басылмалар",
    brandTagline: "экология · коом",
    ariaOpenMenu: "Менюну ачуу",
    ariaCloseMenu: "Менюну жабуу",
    footer: {
      aboutTitle: "Биз жөнүндө",
      aboutBlurb:
        "2009-жылы Бишкекте негизделген көз карандысыз коммерциялык эмес жана аналитикалык борбор.",
      resourcesTitle: "Ресурстар",
      contactsTitle: "Байланыш",
      socialTitle: "Социалдык тармактар",
      bottomTagline: "Далилдүү саясат жана диалог",
    },
  },
};

export function getShellStrings(locale: Locale): ShellStrings {
  return byLocale[locale] ?? byLocale.ru;
}
